import { useState } from 'react'
import { Combobox } from '../components/Combobox'
import { Checkbox } from '../components/Checkbox'
import { Button } from '../components/Button'
import { FormFieldset, FormInput, FormUpload, ShippingForm } from '../components/Fieldset'
import { RadioCardGroup } from '../components/RadioCardGroup'
import Switch from '../components/Switch'
import Tabs from '../components/Tabs'
import PopoverMenu from '../components/PopoverMenu'
import { Modal } from '../components/Modal'
import DropdownMenu from '../components/DropdownMenu'
import { FaMosque, FaTrash } from 'react-icons/fa'
import { FaPencil } from 'react-icons/fa6'
import Disclosure from '../components/Disclosure'
import Carousel from '../../public/components/Carousel'
import IconLabel from '../../public/components/IconLabel'
import ProgressBar from '../components/ProgressBar'
import Card from '../../public/components/Card'
import CarouselCards from '../../public/components/CarouselCards'
import QuranQuote from '../../public/components/QuranQuote'
import DialogModal from '../components/DialogModal'

const solutionsItems = [
    {
        title: 'Insights',
        description: 'Measure actions your users take',
        href: '#',
    },
    {
        title: 'Automations',
        description: 'Create your own targeted content',
        href: '#',
    },
    {
        title: 'Reports',
        description: 'Keep track of your growth',
        href: '#',
    },
]

const solutionsSections = [
    [
        {
            title: 'Documentation',
            description: 'Start integrating products and tools',
            href: '#',
        },
    ],
]

const plans = [
    {
        name: 'Startup',
        description: 'Good for early-stage projects and side hustles.',
    },
    {
        name: 'Business',
        description: (
            <ul className='ml-4 text-sm text-gray-500 list-disc'>
                <li>Up to 8 team members</li>
                <li>Basic analytics</li>
                <li>Email support</li>
            </ul>
        ),
    },
    {
        name: 'Enterprise',
        description: 'For large teams with advanced needs and SLA support.',
    },
]

const tabs = [
    {
        name: 'Recent Posts',
        items: [
            {
                title: 'How to Start a Project',
                href: '/start',
                description: 'A brief guide to getting started.',
                meta: ['Jan 10, 2025', '8 comments', '2 shares'],
            },
            {
                title: 'Tailwind Tips',
                href: '/tailwind',
                meta: ['Feb 5, 2025'],
            },
        ],
    },
    {
        name: 'Empty Tab',
    },
]

const people = [
    { id: 1, label: 'Tom Cook' },
    { id: 2, label: 'Wade Cooper' },
    { id: 3, label: 'Tanya Fox' },
    { id: 4, label: 'Arlene Mccoy' },
    { id: 5, label: 'Devon Webb' },
]

const slides = [
    <img src='/slide1.jpg' alt='Slide 1' className='object-cover w-full h-full' />,
    <img src='/slide2.jpg' alt='Slide 2' className='object-cover w-full h-full' />,
    <div className='flex items-center justify-center h-full text-xl text-white bg-yellow-500'>
        Custom Content
    </div>,
]

const campaigns = [
    {
        imageSrc: 'https://placekittens.com/500/1000',
        label: 'Food Distribution',
        description: (
            <div className='space-y-3 text-sm text-gray-600'>
                <strong>Urgent:</strong> We're raising funds to provide food and shelter after the
                recent disaster.
                <ProgressBar
                    labelLeft='75% donation goal reached'
                    labelRight='$2000 out of $3000 goal'
                    percentage={75}
                />
            </div>
        ),
        buttonLabel: 'Donate',
        onButtonClick: () => alert('Donate to Food Distribution'),
    },
    {
        imageSrc: 'https://placekittens.com/500/1000',
        label: 'School Supplies',
        description: (
            <div className='space-y-3 text-sm text-gray-600'>
                <strong>Urgent:</strong> We're raising funds to provide food and shelter after the
                recent disaster.
                <ProgressBar
                    labelLeft='75% donation goal reached'
                    labelRight='$2000 out of $3000 goal'
                    percentage={75}
                />
            </div>
        ),
        buttonLabel: 'Support',
        onButtonClick: () => alert('Support School Supplies'),
    },
    {
        imageSrc: 'https://placekittens.com/500/1000',
        label: 'Clean Water',
        description: (
            <div className='space-y-3 text-sm text-gray-600'>
                <strong>Urgent:</strong> We're raising funds to provide food and shelter after the
                recent disaster.
                <ProgressBar
                    labelLeft='75% donation goal reached'
                    labelRight='$2000 out of $3000 goal'
                    percentage={75}
                />
            </div>
        ),
        buttonLabel: 'Contribute',
        onButtonClick: () => alert('Contribute to Clean Water'),
    },
]

export default function Components() {
    const [selectedPerson, setSelectedPerson] = useState(null)
    const [checked, setChecked] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState(plans[0])
    const [enabled, setEnabled] = useState(false)
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className='flex flex-col gap-4 p-10'>
            <FormUpload label='Upload Image' name='uploadImage' id='uploadImage' required />
            <IconLabel icon={FaMosque} label='Sharia compliant' />
            <div>
                <button
                    onClick={() => setIsOpen(true)}
                    className='px-4 py-2 text-white bg-yellow-600 rounded'
                >
                    Open Dialog
                </button>

                <DialogModal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    title='Support Our Work'
                    size='md'
                >
                    <p className='text-gray-700'>
                        Your support helps us continue providing aid and services to those in need.
                    </p>
                    <div className='mt-6 text-right'>
                        <button
                            className='px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700'
                            onClick={() => setIsOpen(false)}
                        >
                            Donate Now
                        </button>
                    </div>
                </DialogModal>
            </div>
            <ProgressBar
                labelLeft='75% donation goal reached'
                labelRight='$2000 out of $3000 goal'
                percentage={75}
            />
            <Card
                imageSrc='https://placekittens.com/500/1000'
                label='Disaster Relief'
                // description='Help us provide urgent support.'
                buttonLabel='Donate'
                buttonVariant='primary'
                buttonSize='medium'
                onButtonClick={() => alert('Donated!')}
            >
                <div className='space-y-3 text-sm text-gray-600'>
                    <strong>Urgent:</strong> We're raising funds to provide food and shelter after
                    the recent disaster.
                    <ProgressBar
                        labelLeft='75% donation goal reached'
                        labelRight='$2000 out of $3000 goal'
                        percentage={75}
                    />
                </div>
            </Card>

            <div>
                <span>Combobox</span>
                <Combobox
                    options={people}
                    selectedOption={selectedPerson}
                    onSelect={setSelectedPerson}
                    placeholder='Select a person'
                    className='w-64'
                />

                {/* Non-searchable version */}
                <Combobox
                    options={people}
                    selectedOption={selectedPerson}
                    onSelect={setSelectedPerson}
                    placeholder='Select a person'
                    className='w-64 mt-4'
                    searchable={false}
                />
            </div>
            <div>
                <span>Checkbox</span>
                <Checkbox
                    checked={checked}
                    onChange={setChecked}
                    label='I agree to terms and conditions'
                />
            </div>
            <div>
                <span>Buttons</span>
                {/* // Primary button (default) */}
                <div className='flex items-center gap-4'>
                    <Button>Save Changes</Button>

                    {/* // Danger button */}
                    <Button variant='danger'>
                        <FaTrash className='text-xs' /> Delete
                    </Button>

                    {/* // Secondary button */}
                    <Button variant='secondary'>Cancel</Button>

                    {/* // Disabled button */}
                    <Button variant='disabled'>Processing...</Button>

                    {/* // Large danger button */}
                    <Button variant='danger' size='large'>
                        Confirm Delete
                    </Button>
                </div>
            </div>
            <div>
                <span>Fieldset components</span>
                <ShippingForm />

                <FormFieldset title='Payment Information' className='mt-6'>
                    <FormInput label='Card Number' name='cardNumber' />
                    <div className='grid grid-cols-2 gap-4'>
                        <FormInput
                            label='Name'
                            description='Use your real name so people will recognize you.'
                            name='expiry'
                        />
                        <FormInput label='CVV' name='cvv' />
                    </div>
                </FormFieldset>
            </div>

            <div>
                <span>HeadlessRadio Card Group</span>
                <RadioCardGroup items={plans} selected={selectedPlan} onChange={setSelectedPlan} />
            </div>

            <div>
                <span>Switch Button</span>
                <br />
                <Switch checked={enabled} onChange={setEnabled} label='Enable notifications' />
            </div>

            <div>
                <span>Tabs</span>
                <Tabs tabs={tabs} />
            </div>

            <div>
                <span>Popover</span>
                <div className='flex gap-8'>
                    <div className='text-sm font-semibold text-gray-600'>Products</div>
                    <PopoverMenu
                        buttonText='Solutions'
                        items={solutionsItems}
                        sections={solutionsSections}
                    />
                    <div className='text-sm font-semibold text-gray-600'>Pricing</div>
                </div>
            </div>

            <div className=''>
                <span>Modal</span>
                <Modal
                    triggerText='Open warning'
                    title='Important Notice'
                    triggerVariant='danger'
                    confirmVariant='secondary'
                    confirmText='I Understand'
                >
                    <p>This action cannot be undone.</p>
                    <p className='mt-2'>Are you sure you want to proceed?</p>
                </Modal>
            </div>
            <div>
                <span>DropdownMenu</span>
                <br />
                <DropdownMenu
                    label='Manage'
                    items={[
                        {
                            label: 'Edit',
                            icon: <FaPencil className='w-4 h-4 text-gray-400' />,
                            onClick: () => alert('Edit clicked'),
                        },
                        {
                            label: 'Delete',
                            icon: <FaTrash className='w-4 h-4 text-gray-400' />,
                            onClick: () => alert('Delete clicked'),
                        },
                    ]}
                />
            </div>
            <div>
                <span>Disclosure</span>
                <Disclosure
                    items={[
                        {
                            question: 'What is your refund policy?',
                            answer: 'If you’re unhappy with your purchase, we’ll refund you in full.',
                            defaultOpen: true,
                        },
                        {
                            question: 'Do you offer technical support?',
                            answer: 'Not at the moment.',
                        },
                    ]}
                />
            </div>

            <div>
                <span>Carousel</span>
                <Carousel items={slides} autoPlay interval={4000} />
            </div>

            <div>
                <span>Carousel with Cards</span>
                <CarouselCards items={campaigns} cardsPerPage={2} />
            </div>
            <div className='max-w-xl'>
                <span>Quran Quote</span>
                <QuranQuote
                    verse='إِنَّ مَعَ الْعُسْرِ يُسْرًا'
                    translation='Indeed, with hardship comes ease.'
                    source="Qur'an 94:6"
                />
            </div>
        </div>
    )
}
